import styled from "styled-components";
import colours from "../../lib/colours";

const Dropdown = styled.select`
  height: 36px;
  font-size: 16px;
  font-family: "vic";
  font-weight: 500;
  background-color: ${colours.white};
  border: 1px solid ${colours.grey1};
  border-radius: 4px;
  padding-right: 20px;
  padding-left: 4px;
  cursor: pointer;

  &:disabled {
    border-color: ${colours.grey2};
    cursor: not-allowed;
  }
`;

export default Dropdown;
